<div id="{{ vimeoPlayerDomId }}" class="vimeo-video-player"
     (pcpResized)="videoHotspontsContainer.onVideoResized($event, getClientWidth(), getClientHeight())"
></div>

<pcp-video-hotspots
    #videoHotspontsContainer
    [debug]="debug"
    [visibleHotspots]="(visibleHotspots$|async) ?? []"
    [slideId]="video.slideId"
    (hotspotClicked)="activateHotspot($event)"
></pcp-video-hotspots>
